import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import * as globals from '../settings';
import {LotteriesService} from '../lotteries.service';

@Injectable()
export class JackpotConfigService {
    jackpotConfig: any;
    downloadedData: boolean;

    constructor(public lotteryService: LotteriesService, private http: HttpClient) {
        this.downloadedData = false;
        this.lotteryService.getLotteries(globals.appDomain + '/Config/getJackpotConfig/jackpotConfig.json')
            .subscribe(
                result => {
                    this.jackpotConfig = result.message;
                    this.downloadedData = true;
                }
            );
    }
}
